export function capitalizeFirstLetter(targetString: string): string {
  if (targetString)
    return targetString
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  return targetString;
}
